var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ckTextEditor mailBody"},[_c('div',{staticClass:"blockSection"},[_c('div',{ref:"editorElement",staticStyle:{"width":"100%","height":"200px"},style:({ height: _vm.height })})])])}
var staticRenderFns = []

export { render, staticRenderFns }